import React from 'react';
import { useParams } from 'react-router-dom';

import {
  BatchDetails,
  useGetSuperBatchModulesQuery,
} from 'features/moduleManagement';
import AddSuperBatchModuleModal from './AddSuperBatchModuleModal';
import DeleteSuperBatchModuleModal from './DeleteSuperBatchModuleModal';
import ErrorLayout from 'components/ErrorLayout';
import GlobalLoader from 'components/GlobalLoader';
import Loader from 'components/Loader';
import SuperBatchModulesTableRenderer from './SuperBatchModulesTableRenderer';
import SaveOrderChangesButton from './SaveOrderChangesButton';
import UpdateSuperBatchModuleStatusModal from './UpdateSuperBatchModuleStatusModal';
import UpdateSuperBatchModuleInterviewModal from './UpdateSuperBatchModuleInterviewModal';

function ManageBatchModulePage() {
  const { batch: superBatchId } = useParams();
  const { isLoading, data, error, refetch, isFetching } =
    useGetSuperBatchModulesQuery(superBatchId);

  if (isLoading) {
    return <Loader />;
  } else if (error) {
    return (
      <ErrorLayout
        title="Failed to load Super Batch modules"
        message={error.data?.message || 'Something went wrong! Try again later'}
        actionFn={refetch}
      />
    );
  } else if (data?.data) {
    const meta = data.meta;
    const superBatchModules = data.data;
    const { super_batch: superBatch } = meta;

    return (
      <>
        <GlobalLoader isVisible={isFetching} />
        <DeleteSuperBatchModuleModal />
        <UpdateSuperBatchModuleStatusModal />
        <UpdateSuperBatchModuleInterviewModal />
        <AddSuperBatchModuleModal superBatch={superBatch} />
        <div className="row space-between m-t-m">
          <BatchDetails superBatch={superBatch} />
        </div>
        <SuperBatchModulesTableRenderer superBatchModule={superBatchModules} />
        {superBatchModules.length > 0 && <SaveOrderChangesButton />}
      </>
    );
  }
}

export default ManageBatchModulePage;
